module.exports = __webpack_public_path__ + "static/media/newsletter.9cb87487.jpg";